import query from 'components/account/query.graphql'
import { cloneDeep } from 'lodash/lang'

const updateCache = ({ entity, fieldGroup, mutationName }) => {
  // https://www.apollographql.com/docs/react/essentials/mutations/#updating-the-cache
  return (cache, mutationResult) => {
    // get any errors from the result
    const { data } = mutationResult

    const errors = data[mutationName].errors || {}

    // don't update cache if we have errors
    if (errors.length > 0) {
      return null
    }

    // Fetch the currently cached account overview query.
    const clonedData = cloneDeep(cache.readQuery({ query: query }))

    // find the entity in the cache and remove it
    const index = clonedData.viewer[fieldGroup].findIndex(
      x => x.id === entity.id
    )
    if (index >= 0) {
      clonedData.viewer[fieldGroup].splice(index, 1)
    }

    // save the query back to the cache
    cache.writeQuery({
      query: query,
      data: clonedData
    })
  }
}

export default updateCache
